const $$splitComponentImporter = () => import('/app/apps/webapp/src/app/routes/_public/forgot-password.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_public/forgot-password')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});